export default __webpack_public_path__ + "static/media/LeZilver.ddfcb0c1.png";